/** Builds a light+dark status badge class string for a given Tailwind color name. */
export function statusColor(color: string): string {
  return `bg-${color}-100 text-${color}-800 dark:bg-${color}-500/25 dark:text-${color}-200`;
}

/** Semantic status palette. Import specific entries for domain colorMaps. */
export const STATUS_PALETTE = {
  success: statusColor("emerald"),
  error: statusColor("red"),
  warning: statusColor("amber"),
  info: statusColor("blue"),
  neutral: statusColor("gray"),
  processing: statusColor("indigo"),
  teal: statusColor("teal"),
  violet: statusColor("violet"),
  sky: statusColor("sky"),
  rose: statusColor("rose"),
  purple: statusColor("purple"),
  yellow: statusColor("yellow"),
} as const;
